import React, { useState } from 'react';

import { useSelector } from 'react-redux';

import { Tooltip } from 'antd';

import { isTourPublic } from 'app/constants/tourAccessibilityTypes.constants';
import { getContainingTourFolders } from 'app/components/Desctop/Folders/folder.utils';
import withTranslations from 'app/components/HOGs/withTranslations';
import withMobileDetecting from 'app/components/HOGs/detectMobileDesign';
import { useActions } from 'app/components/Utility/hooks/useAction.hooks';
import { applyingTypes } from 'app/constants/folder.constants';
import { AccessTypeWrapper } from '../../TourFullView/CreateTour/AccesibilityType/AccessTypeWrapper';
import FolderMenuButton from '../../Folders/FolderMenu';

import { ShareIcon } from '../../TourstartAcademy/academy.svg';
import ShareTour from '../../Tour/ShareTour';
import {
  PublicTourIcon,
  PrivateTourIcon,
} from '../../TourFullView/components/svg';

const PlaceAccessTypes = ({ tr, isMobileDesign }) => {
  const { PlaceSetEditMode, setAccessibilityPlaceType } = useActions();
  const isEditMode = useSelector((store) => store.placesData.isEditMode);
  const data = useSelector((store) => store.placesData.data);
  const owner = useSelector((store) => store.placesData.data.user);
  const folders = useSelector((store) => store.foldersPlace);
  const isLoggedIn = useSelector((store) => store.authentication.isLoggedIn);
  const user = useSelector((store) => store.authentication.user);

  const [sharing, handleShare] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const placeId = data?.id;
  const selectedFolders = getContainingTourFolders(folders, +placeId);
  const url = data?.url?.slice(6) || '';

  const getCurrentUserId = () => {
    return isLoggedIn && user ? user.id : 0;
  };

  const hasUserPermition = () => {
    const id = getCurrentUserId();
    return id && id === +owner?.id;
  };

  const activateShare = () => {
    setTooltipVisible(false);
    handleShare(true);
  };

  const editChoose = (mode) => {
    if (hasUserPermition()) {
      const editMode = mode || !isEditMode;
      PlaceSetEditMode(editMode);
    }
  };

  const updateTypes = (data) => {
    setAccessibilityPlaceType(data);
  };

  return (
    <div className="tourPermissionType">
      {!isEditMode ? (
        <>
          <FolderMenuButton
            tourId={placeId}
            folders={folders}
            selectedFolders={selectedFolders}
            applying={applyingTypes.PLACE_FOLDER}
          />

          <Tooltip title={tr['Share tour']} visible={tooltipVisible}>
            <ShareIcon
              width="18px"
              height="18px"
              className="share_icon"
              onClick={() => activateShare()}
              onMouseEnter={() => setTooltipVisible(true)}
              onMouseLeave={() => setTooltipVisible(false)}
            />
          </Tooltip>
        </>
      ) : null}
      {hasUserPermition() ? (
        <AccessTypeWrapper
          tr={tr}
          data={data}
          currentUserId={getCurrentUserId()}
          mobile={isMobileDesign}
          editChoose={editChoose}
          isEditMode={isEditMode}
          activePart={data}
          updateTypes={updateTypes}
          placeType={data.access}
        />
      ) : (
        <div className="acceessibility-tour-dropdown-button-view">
          {isTourPublic(data.access) ? <PublicTourIcon /> : <PrivateTourIcon />}
          {isTourPublic(data.access) ? tr.Public : tr.Private}
        </div>
      )}
      {sharing ? (
        <ShareTour
          tourUrl={url}
          shown={sharing}
          cancel={() => handleShare(false)}
        />
      ) : null}
    </div>
  );
};

export default withTranslations(withMobileDetecting(PlaceAccessTypes));
